export function getUrlEnvironment() {
  const domain = getDomainLevel(3);

  if (domain === "localhost") {
    return "development";
  } else {
    return (domain.match(/[^-]+-([a-z0-9A-Z]+)\./) || [])[1] || "production";
  }
}

export function getDomainLevel(level: 1 | 2 | 3) {
  return window.location.hostname
    .split(".")
    .slice(-1 * level)
    .join(".");
}

export function getServerUrl(devServerPort: string) {
  const envName = getUrlEnvironment();

  if (envName === "development") {
    return "http://localhost:" + devServerPort + "/graphql";
  }

  return (
    "https://" + window.location.host.replace(/^([^-.]+)/, "api") + "/graphql"
  );
}

export function getUrlOrgId() {
  const env = getUrlEnvironment();

  if (env === "development") {
    return window.location.href.split("/")[4];
  }

  return window.location.pathname.split("/")[1];
}
